<template>
  <div class="cases">
    <!-- 导航栏 -->
    <Navbar :entName="entName" :logo="logo" />

    <!-- 页面 Banner -->
    <section class="page-banner">
      <div class="container">
        <h1>成功案例</h1>
        <p>来自多个行业的客户实践，见证数字化转型的真实价值</p>
      </div>
    </section>

    <!-- 页面内容 -->
    <section class="cases-content">
      <div class="container">
        <div class="cases-grid">
          <div class="case-card" v-for="caseItem in cases" :key="caseItem.id">
            <div class="case-image">
              <img :src="caseItem.img" :alt="caseItem.title" />
            </div>
            <h4>{{ caseItem.title }}</h4>
            <p>{{ caseItem.contentSimple }}</p>
            <router-link :to="`/case/caseDetail?id=${caseItem.id}`" class="btn"
              >查看详情</router-link
            >
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <Footer v-bind="footerData" />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import api from "@/api";
import { pageDataMixin } from "@/mixins/pageData";

export default {
  name: "Cases",
  components: {
    Navbar,
    Footer,
  },
  mixins: [pageDataMixin],
  data() {
    return {
      cases: []
    };
  },
  mounted() {
    this.fetchCases();
  },
  methods: {
    fetchCases() {
      api.get("/api/case/getCaseList")
        .then(response => {
          if (response.data.code === 0) {
            this.cases = response.data.data;
          }
        })
        .catch(() => {
          // 静默处理错误
        });
    }
  }
};
</script>

<style scoped>
.cases {
  font-family: Arial, sans-serif;
}

/* 通用样式 */
.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

/* ========= Banner ========= */
.page-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4rem 0;
  text-align: center;
}
.page-banner h1 {
  font-size: 2.5rem;
  margin: 0 0 0.5rem 0;
  font-weight: 600;
}
.page-banner p {
  margin: 0;
  font-size: 1.1rem;
  opacity: 0.9;
}

.cases-content {
  padding: 3rem 0;
}

.cases-section .container {
  flex-direction: column;
  align-items: center;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin: 2rem auto;
  width: 100%;
  max-width: 1100px;
}

@media (max-width: 1200px) {
  .cases-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .cases-grid {
    grid-template-columns: 1fr;
  }
}

.case-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 400px;
}

.case-card:hover {
  transform: translateY(-5px);
}

.case-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.case-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
}

.case-card h4 {
  margin: 1.5rem 1.5rem 0.5rem;
  font-size: 1.1rem;
  font-weight: bold;
}

.case-card p {
  margin: 0 1.5rem 1.5rem;
  font-size: 0.9rem;
  color: #666;
  line-height: 1.4;
  flex-grow: 1;
}

.btn {
  display: inline-block;
  background-color: #007bff;
  color: white;
  padding: 0.8rem 1.5rem;
  text-decoration: none;
  border-radius: 50px;
  transition: background-color 0.3s ease;
  width: auto;
  white-space: nowrap;
  text-align: center;
  margin: 0 1.5rem 1.5rem;
}

.btn:hover {
  background-color: #0069d9;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .nav-links {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .cases-grid {
    grid-template-columns: 1fr;
  }

  .footer-content {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }

  .footer-details {
    flex-direction: column;
    min-width: 100%;
  }

  .company-info {
    min-width: 100%;
    text-align: center;
  }

  .company-info h3,
  .company-info p {
    text-align: center;
  }

  .core-business h4 {
    text-align: center;
  }

  .core-business p,
  .contact-info p {
    text-align: center;
  }
}
</style>